module.exports = require('./lib/linkify-html').default;



// WEBPACK FOOTER //
// ./~/linkifyjs/html.js